import * as React from "react";
import { MyAccountLayout, OnlyOnClient, Protected, PageWithMenu } from "@grandvisionhq/my-account";
import { useIntl } from "@grandvisionhq/state";
import { monetate } from "@grandvisionhq/svc-monetate";
const ProtectedPageLayout = ({
  pageKey,
  backAttributes,
  children
}) => {
  const { getLabel } = useIntl();
  const { href, onClick } = backAttributes ?? {};
  const getRoutingLink = (backAttributes2) => {
    if (!href || !onClick) {
      return;
    }
    return {
      href,
      onClick,
      label: getLabel(`account.menu.${backAttributes2.labelKey}`)
    };
  };
  React.useEffect(() => {
    monetate().commitMonetateEvent("my-account");
  }, []);
  return /* @__PURE__ */ React.createElement(MyAccountLayout, null, /* @__PURE__ */ React.createElement(OnlyOnClient, null, /* @__PURE__ */ React.createElement(Protected, { key: pageKey }, /* @__PURE__ */ React.createElement(PageWithMenu, { backRouteLinkAttributes: backAttributes && getRoutingLink(backAttributes) }, children))));
};
export {
  ProtectedPageLayout as P
};
//# sourceMappingURL=protected-page.js.map
